// Panel adresleri (2026-10-14 ürün kararı: kullanıcının gördüğü hiçbir yerde İngilizce yok). Adres çubuğundaki her yol
// Türkçe; kod adları İngilizce kalır: portal anahtarı kodda `control` / `business`, adreste `/operasyon` / `/kurum`.
import { REPORT_SLUG, reportTypeFromSlug, type ReportType } from '@serota/domain';

export type Portal = 'control' | 'business';

/** Servis firması paneli (SEROTA Operasyon). */
export const CONTROL = '/operasyon';
/** Okul ve şirket kurum paneli (SEROTA Kurum). */
export const BUSINESS = '/kurum';
export type PortalBase = typeof CONTROL | typeof BUSINESS;

export const PORTAL_BASE: Record<Portal, PortalBase> = { control: CONTROL, business: BUSINESS };

/** Ürün adı: tarayıcı sekmesi başlığında sayfa adından sonra yazılır. */
export const PRODUCT_NAME: Record<PortalBase, string> = { [CONTROL]: 'SEROTA Operasyon', [BUSINESS]: 'SEROTA Kurum' };

/** Yol kurum panelinde mi (`/kurum` veya `/kurum/...`)? */
export const isBusinessPath = (pathname: string): boolean =>
  pathname === BUSINESS || pathname.startsWith(`${BUSINESS}/`);

/** Rapor adresleri Türkçe (`/operasyon/raporlar/zamaninda-varis`); tek kaynak @serota/domain (API dışa aktarma adıyla aynı). */
export { REPORT_SLUG, reportTypeFromSlug };

export const reportPath = (portal: Portal, type: ReportType): string =>
  `${PORTAL_BASE[portal]}/raporlar/${REPORT_SLUG[type]}`;
